var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorialvideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 140C110.899 140 140 110.899 140 75C140 39.1015 110.899 10 75 10C39.1015 10 10 39.1015 10 75C10 110.899 39.1015 140 75 140Z",
    fill: "#EEFFFF",
    fillOpacity: 0.560784
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 138C109.794 138 138 109.794 138 75C138 40.2061 109.794 12 75 12C40.2061 12 12 40.2061 12 75C12 109.794 40.2061 138 75 138Z",
    stroke: "#032746",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 85L47.5 65C48.75 62.5 51.25 61.25 53.75 61.25H96.25C98.75 61.25 101.25 62.5 102.5 65L112.5 85H37.5Z",
    fill: "white",
    stroke: "#032746",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 97.5H116.25C117.5 97.5 118.75 96.25 118.75 95V85C118.75 83.75 117.5 82.5 116.25 82.5H33.75C32.5 82.5 31.25 83.75 31.25 85V95C31.25 96.25 32.5 97.5 33.75 97.5Z",
    fill: "white",
    stroke: "#032746",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 65H96.25L93.75 76.25H56.25L53.75 65Z",
    fill: "#EEFFFF",
    fillOpacity: 0.560784,
    stroke: "#032746",
    strokeWidth: 1.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 106.25C54.8325 106.25 58.75 102.332 58.75 97.5C58.75 92.6675 54.8325 88.75 50 88.75C45.1675 88.75 41.25 92.6675 41.25 97.5C41.25 102.332 45.1675 106.25 50 106.25Z",
    fill: "#032746"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101.25C52.0711 101.25 53.75 99.5711 53.75 97.5C53.75 95.4289 52.0711 93.75 50 93.75C47.9289 93.75 46.25 95.4289 46.25 97.5C46.25 99.5711 47.9289 101.25 50 101.25Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100 106.25C104.832 106.25 108.75 102.332 108.75 97.5C108.75 92.6675 104.832 88.75 100 88.75C95.1675 88.75 91.25 92.6675 91.25 97.5C91.25 102.332 95.1675 106.25 100 106.25Z",
    fill: "#032746"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100 101.25C102.071 101.25 103.75 99.5711 103.75 97.5C103.75 95.4289 102.071 93.75 100 93.75C97.9289 93.75 96.25 95.4289 96.25 97.5C96.25 99.5711 97.9289 101.25 100 101.25Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 87.5C45.1307 87.5 46.25 86.3807 46.25 85C46.25 83.6193 45.1307 82.5 43.75 82.5C42.3693 82.5 41.25 83.6193 41.25 85C41.25 86.3807 42.3693 87.5 43.75 87.5Z",
    fill: "#FFE082"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.25 87.5C107.631 87.5 108.75 86.3807 108.75 85C108.75 83.6193 107.631 82.5 106.25 82.5C104.869 82.5 103.75 83.6193 103.75 85C103.75 86.3807 104.869 87.5 106.25 87.5Z",
    fill: "#FFE082"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93.75C85.3553 93.75 93.75 85.3553 93.75 75C93.75 64.6447 85.3553 56.25 75 56.25C64.6447 56.25 56.25 64.6447 56.25 75C56.25 85.3553 64.6447 93.75 75 93.75Z",
    fill: "#032746",
    fillOpacity: 0.9
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 65V85L87.5 75L67.5 65Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78.75V97.5",
    stroke: "#032746",
    strokeWidth: 0.625
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 87.5H93.75",
    stroke: "#032746",
    strokeWidth: 0.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialvideo);
export default __webpack_public_path__ + "static/media/tutorialvideo.64b92bafcf0afa0a3a61063861857f27.svg";
export { ForwardRef as ReactComponent };